import type { AircraftModelId, ModelServiceIntervalMap, ServiceIntervalMap } from '../../types';

// Resolves the editable service-interval map for a single aircraft model.
export const getModelIntervals = ({
    model,
    serviceIntervals
}: {
    model: AircraftModelId;
    serviceIntervals: ModelServiceIntervalMap;
}): ServiceIntervalMap => serviceIntervals[model];
